export class BookingAddon {
    public bookingId: string;
    public addonId: string;
    public organizationId: string;
    public isDeleted: boolean;
    public createdBy: string;
    public createdDate: Date;
    public lastEditedBy: string;
    public lastEditedDate: Date;
}